/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import BarChart from 'loracoms/BarChart';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';
import { toDistrTrendOption } from '../selectors';


const defaultProps = {
  resize: 0,
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  option: React.PropTypes.object.isRequired,
  resize: React.PropTypes.number,
};

class GatewaySFTrend extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      option: props.option,
      resize: props.resize,
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.statschart');
  }

  componentWillReceiveProps(nextProps) {
    const { option, resize } = nextProps;
    if (option !== this.props.option) {
      this.setState({ option });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize });
    }
  }

  render() {
    const { option, resize } = this.state;
    return (
      <div className={styles.chart}>
        <BarChart
          yAxis={{
            name: this.intlMsg.msg('axis.pkts'),
            splitNumber: 5,
          }}
          xAxis={{
            axisTick: { interval: 0 },
            splitArea: {
              show: true,
              interval: 0,
              areaStyle: { color: ['rgba(218, 223, 225, 0.2)', '#FFFFFF'] },
            },
          }}
          legend={{
            data: option.legend,
          }}
          dataZoom={[
            {
              fillerColor: 'rgba(228, 241, 254, 0.4)',
              dataBackground: {
                lineStyle: {
                  width: 0,
                },
                areaStyle: {
                  color: 'rgba(107, 185, 240, 0.8)',
                },
              },
            },
          ]}
          grid={{
            left: 60,
            top: 30,
            right: 30,
            bottom: 60,
          }}
          series={option.series}
          categories={option.categories}
          resize={resize}
        />
      </div>
    );
  }
}


GatewaySFTrend.defaultProps = defaultProps;
GatewaySFTrend.propTypes = propTypes;

const mapStateToProps = state => ({
  option: toDistrTrendOption('sf')(state),
});

export default connect(
  mapStateToProps,
  null,
)(injectIntl(GatewaySFTrend));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewaySFTrend/index.jsx